

















import Vue from 'vue';

export default Vue.extend({
  name: 'PrintableMultiselect',
  props: {
    value: {
      type: [Array, String, Object],
      default: () => [],
    },
    placeholder: {
      type: String,
      default: 'None',
    },
    label: {
      type: String,
      default: 'label',
    },
  },
  data() {
    return {};
  },
  computed: {
    selectedOptions() {
      const arrayToLabels = (optsArray: Array<any>, key: String) => {
        const isArrayOfString = isArray && typeof this.value[0] === 'string';
        return isArrayOfString ? optsArray : optsArray.map(value => value[key]);
      };

      const isArray = Array.isArray(this.value);
      const isObject = typeof this.value === 'object';
      const result = isArray
        ? arrayToLabels(this.value, this.label)
        : isObject
        ? [this.value[this.label]]
        : [this.value].filter(v => v);
      return result.length ? result : [this.placeholder];
    },
  },
});
